import { FormItem, Option, TableColumns } from 'interfaces';
import { SelectFormInput } from 'shared-components';

import { REQUIRED_MESSAGE } from './global';
import { FieldTypes } from './shared';

export enum CreateCustomMailFieldNames {
  TYPE = 'type',
  ENTITY = 'entity',
}

export const addPaddingToTd = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const tdElements = doc.querySelectorAll('td');

  tdElements.forEach((td) => {
    let currentStyle = td.getAttribute('style') || '';

    if (!/padding\s*:/.test(currentStyle)) {
      currentStyle = currentStyle.trim();
      if (currentStyle && !currentStyle.endsWith(';')) {
        currentStyle += ';';
      }
      currentStyle += ' padding: 24px;';
      td.setAttribute('style', currentStyle);
    }
  });

  return doc.body.innerHTML;
};

export const CREATE_CUSTOM_MAIL_FORM_FIELDS = (entityOptions: Option[]): FormItem[] => {
  return [
    {
      name: `${CreateCustomMailFieldNames.ENTITY}`,
      label: 'Entity',
      placeholder: 'Select Entity',
      type: FieldTypes.SELECT,
      component: SelectFormInput,
      required: true,
      options: entityOptions,
      className: 'col-span-full mb-4',
      validation: { required: REQUIRED_MESSAGE },
    },
  ];
};

export enum MAILING_PAGE_TABS_IDS {
  CREATION = 'creation',
  SENT = 'sent',
}

export const SENT_MAIL_TABLE_COLUMNS: TableColumns[] = [
  { id: 'email', title: 'Email address' },
  { id: 'subject', title: 'Subject' },
  { id: 'body', title: 'Body' },
  { id: 'createdAt', title: 'Created at' },
  { id: 'preview', title: '' },
];
